module.exports = __webpack_public_path__ + "static/3-f55d9e4e766697b24441307715c0959e.jpg";